import {
  SectionElement,
  defineElement,
  globalOn,
  query
} from "./chunk-POAMU4SL.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/sections/common-references-small/common-references-small.ts
var CommonReferences = class extends SectionElement {
  init() {
    this.swiper.swiperInstance.slideTo(Math.floor(this.swiper.swiperInstance.slides.length / 2));
  }
};
__decorateClass([
  query("[data-reference-swiper-small]")
], CommonReferences.prototype, "swiper", 2);
__decorateClass([
  globalOn("referenceSliderSmall:init")
], CommonReferences.prototype, "init", 1);
CommonReferences = __decorateClass([
  defineElement("common-references-small")
], CommonReferences);
export {
  CommonReferences
};
